// extracted by mini-css-extract-plugin
export default {"card":"round-card_card__vHYnN"};